import axios from "axios"
import { Message } from 'element-ui';
import Vue from 'vue';


// 创建实例
// 封装axios请求，可以从axios官网获取
const instance = axios.create({
    // 基础url,家里
    // baseURL: 'http://192.168.124.18:8081',
    // 手机wifi
    // baseURL: 'http://192.168.92.202:8081',
    // 服务器地址
    baseURL: 'https://ailibrary.fun:8081',

    
    // 超时时间
    timeout: 5000,
});

//   配置实例拦截器
// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // 在发送请求时，加入loading加载效果
    console.log('进入请求拦截器');
    
    
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    const res=response.data;
    // 获取响应码
    if(res.status==='500'){
        // 进行提示，使用Toast()
        Message.error(res.message);
    }

    return res;
}, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
});

// 导出
export default instance;


